import React, { useContext } from 'react';
import { Route } from 'react-router-dom';
import { AuthContext } from '../Auth/AuthContext';
import CustomersProvider from '../Customers/CustomersContext';
import OperationsProvider from '../Operations/OperationsContext';
import ReportsProvider from '../Reports/ReportsContext';
import Sales from './Sales';
import Clients from './Clients';
import Operations from './Operations';
import Reports from './Reports';
import Admin from './Admin';

const PageIndex = () => {
	// context
	const {
		authedUser,
		hasSomeRoute
	} = useContext( AuthContext );

	return (
		<div className="dashboardContainer">
			<CustomersProvider authedUser={ authedUser }>
				{ hasSomeRoute( 'leads', 'rfp', 'prospects', 'archived' )
					// authedUser.role.id === 1 || authedUser.role.id === 9 || authedUser.role.id === 4 || authedUser.role.id === 5 || authedUser.role.id === 7
					? <Route
						path="/main/sales"
						component={ Sales }
					/>
					: null
				}
				{ hasSomeRoute( 'clients' )
					// authedUser.role.id === 1 || authedUser.role.id === 9 || authedUser.role.id === 4 || authedUser.role.id === 5 || authedUser.role.id === 7 || authedUser.role.id === 8
					? <Route
						path="/main/clients"
						component={ Clients }
					/>
					: null
				}
			</CustomersProvider>
			{ hasSomeRoute( 'tiers', 'plans', 'rates', 'files', 'procedures', 'renewal' )
			// authedUser.role.id === 1 || authedUser.role.id === 9 || authedUser.role.id === 4 || authedUser.role.id === 7
				? <OperationsProvider>
					<Route
						path="/main/operations"
						component={ Operations }
					/>
				</OperationsProvider>
				: null
			}
			<ReportsProvider>
				{ hasSomeRoute( 'reports' )
					// authedUser.role.id === 9
					? <Route
						path="/main/reports"
						component={ Reports }
					/>
					: null
				}
			</ReportsProvider>
			{ hasSomeRoute( 'admin' )
				// authedUser.role.id === 1 || authedUser.role.id === 9 /* || authedUser.role.id === 4 || authedUser.role.id === 7 */
				? <Route
					path="/main/administration"
					component={ Admin }
				/>
				: null
			}
		</div>
	);
};

export default PageIndex;
